import { render, staticRenderFns } from "./img-text.vue?vue&type=template&id=b5f90e36&scoped=true"
import script from "./img-text.vue?vue&type=script&lang=js"
export * from "./img-text.vue?vue&type=script&lang=js"
import style0 from "./img-text.vue?vue&type=style&index=0&id=b5f90e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f90e36",
  null
  
)

export default component.exports